import { z } from "zod";

export const HAS_EV_OPTIONS = ["Yes", "No", "MaybeSoon"] as const;
export const HOUSE_TYPE_OPTIONS = [
  "Detached",
  "SemiDetached",
  "EndOfTerrace",
  "MidTerrace",
  "Apartment",
  "Bungalow",
] as const;
export const HEATING_TYPE_OPTIONS = [
  "Gas",
  "Hybrid",
  "ElectricHeatPump",
  "ElectricStorageHeater",
] as const;
export const METER_TYPE_OPTIONS = ["Standard", "Economy7", "Smart"] as const;
export const HAS_SOLAR_OPTIONS = ["Yes", "No"] as const;
export const SOLAR_ARRAY_SIZE = ["Small", "Medium", "Large"] as const;

export type HasEv = (typeof HAS_EV_OPTIONS)[number];
export type HouseType = (typeof HOUSE_TYPE_OPTIONS)[number];
export type HeatingType = (typeof HEATING_TYPE_OPTIONS)[number];
export type MeterType = (typeof METER_TYPE_OPTIONS)[number];
export type HasSolar = (typeof HAS_SOLAR_OPTIONS)[number];
export type SolarArraySize = (typeof SOLAR_ARRAY_SIZE)[number];

export const AVERAGE_CONSUMPTION_SCHEMA = z.object({
  postcode: z.string().trim().optional(),
  hasEv: z.enum(HAS_EV_OPTIONS).optional(),
  houseType: z.enum(HOUSE_TYPE_OPTIONS).optional(),
  heatingType: z.enum(HEATING_TYPE_OPTIONS).optional(),
});

export type AverageConsumptionOptions = z.infer<
  typeof AVERAGE_CONSUMPTION_SCHEMA
>;

// @TODO: Once we know more of a direction with the batteries and sales page, we might want to make these more complex and informative
export const BATTERY_CAPACITIES = [2.6, 5.12, 9.5, 13.5] as const;
